import { i18n } from "@lingui/core";
import { messages as enMessages } from "./locales/en/messages.po";
import { messages as esMessages } from "./locales/es/messages.po";

const supportedLocales = ["es", "en"];

i18n.load({
	es: esMessages,
	en: enMessages,
});

i18n.activate(detectBrowserLanguage());

/**
 * Detecta el idioma preferido del navegador entre los soportados.
 * @returns {string} "es" o "en"
 */
export function detectBrowserLanguage() {
	const browserLang = (navigator.language || "en").split("-")[0];
	return supportedLocales.includes(browserLang) ? browserLang : "en";
}

export { i18n };
